import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appScrollToBottom]',
})
export class ScrollToBottomDirective {
  @Input() set appScrollToBottom(_data: any) {
    this.scrollToBottom();
  }

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  private scrollToBottom(): void {
    requestAnimationFrame(() => {
      const element = this.elementRef.nativeElement;

      const scrollContainer = element.closest('app-scrollbar') as HTMLElement;

      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      } else {
        element.scrollTop = element.scrollHeight;
      }
    });
  }
}
